import { StudyTranslation } from '../../../models/study-translation';
import { Language } from '../../../models/language';
import { StudyType } from '../../../models/study-type';

export function isThereEmptyTranslation(translations: StudyTranslation[], identifier?: string): boolean {
  let emptyTranslation = false;
  for (const translation of translations) {
    if (!translation.translation && (identifier ? translation.identifier === identifier : true)) {
      emptyTranslation = true;
    }
  }
  return emptyTranslation;
}

export function areThereValidChoicesMessage(
  supportedLanguages: Language[],
  translations: StudyTranslation[],
  identifier?: string,
  minAnswers?: number,
  maxAnswers?: number,
  allowOther?: boolean
): string {
  const numbersOfChoices = [];

  supportedLanguages.forEach((supportedLanguage) => {
    for (const translation of translations) {
      if (
        translation.translation &&
        translation.identifier === identifier &&
        translation.language === supportedLanguage.code
      ) {
        numbersOfChoices.push(translation.translation.split('\n').filter((row) => row).length);
      }
    }
  });

  if (numbersOfChoices.length !== supportedLanguages.length) {
    return 'You have to give at least 1 choice for each language';
  }

  if (numbersOfChoices.filter(onlyUnique).length !== 1) {
    return 'You have to add translations for all choices';
  }

  if (!isNaN(minAnswers) && !isNaN(maxAnswers) && minAnswers > maxAnswers) {
    return "Minimum can't be greater than maximum";
  }

  if (minAnswers) {
    let errorMsg = '';
    numbersOfChoices.forEach((numberOfChoices) => {
      if (numberOfChoices < (allowOther ? minAnswers - 1 : minAnswers)) {
        errorMsg =
          'You have to give at least ' + (allowOther ? minAnswers - 1 : minAnswers) + ' choices for each language';
      }
    });

    if (errorMsg) {
      return errorMsg;
    }
  }

  return '';
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export function areThereValidLabelsMessage(
  supportedLanguages: Language[],
  translations: StudyTranslation[],
  identifier?: string
): string {
  let numbersOfTranslations = 0;

  supportedLanguages.forEach((supportedLanguage) => {
    for (const translation of translations) {
      if (
        translation.translation &&
        translation.identifier === identifier &&
        translation.language === supportedLanguage.code
      ) {
        numbersOfTranslations++;
      }
    }
  });

  if (supportedLanguages.length !== numbersOfTranslations) {
    return 'You have to add translations for Left and Right labels';
  }

  return '';
}

export function getStudyTypeLabel(studyType: string): string {
  return studyType === StudyType.TIIM ? 'Regular' : 'Career Compass';
}
